import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { ApplicationUserDataService } from "../../core/applicationusers.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";
import appSettings = require("../../core/appsettings");
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: "crew-applicationuser",
    template: require('./application-user.component.html')
})
export class ApplicationUser extends DetailsBase<Nema.Crew.Model.ApplicationUser> {

    isWindowsAuthentication: Observable<boolean>;

    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('applicationUser') applicationUser: Nema.Crew.Model.ApplicationUser,
        @Inject('roles') public roles: Nema.Crew.Model.Role[],
        @Inject(ApplicationUserDataService.Id) applicationUserDataService: ApplicationUserDataService,
        @Inject('$log') $log: ng.ILogService,
        settings: appSettings.AppSettingsService) {
        super(stateService, dialog, applicationUser, applicationUserDataService, $log);

        (<any>this.entity.UserRoles).load();

        this.isWindowsAuthentication = settings.isWindowsAuthentication().pipe(map(res => res.body));
    }

    public entityName = "User";

    public editStateName = "app.settings.applicationusers.edit";

    public listStateName = "app.settings.applicationusers";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/applicationusers/application-user.component.ts